import { api } from "./client";

/** De huidige dataversie van de tenant (`GET /data-version`, plan 17 E4). */
export type DataVersionResponse = { data_version: number | null };

export async function fetchDataVersion(): Promise<DataVersionResponse> {
  const { data } = await api.get<DataVersionResponse>("/data-version");
  return data;
}
